module.exports = Promise.all([__parcel__import__("bB7YO"), __parcel__import__("jRojr")]).then(() => parcelRequire('4MH6n'));